import React from 'react'

import {
    BottonContent,
    Card,
    FontImage,
    Image,
    InformationSection,
    NameEmployed,
    NameTypography,
    PositionEmployed,
    PositionTypography,
    SocialCard,
} from './styles'

import { FooterSocial } from 'src/constants'
import { MeetLabels } from 'src/types'
import { MapSocial } from './mapSocial'
import { useI18nInstance } from 'src/provider/LocaleProvider'

export const MapTeam = ({ image, WorkField, name }: MeetLabels) => {
    const i18n = useI18nInstance()
    return (
        <Card>
            <FontImage>
                <Image src={image} alt={name} />
            </FontImage>
            <InformationSection>
                <NameEmployed
                    marginTop={['xsmall', 'xsmall', 'xxmedium', 'xxmedium']}
                >
                    <NameTypography
                        variant={'h3'}
                        fontSize={['small', 'small', 'medium', 'xxxsmall']}
                        fontWeight={400}
                    >
                        {name}
                    </NameTypography>
                </NameEmployed>
                <PositionEmployed
                    marginTop={['small', 'small', 'xxsmall', 'xxsmall']}
                >
                    <PositionTypography
                        variant={'h2'}
                        fontSize={['min', 'min', 'xxxsmall', 'xxxsmall']}
                        fontWeight={700}
                    >
                        {WorkField}
                    </PositionTypography>
                </PositionEmployed>
                <SocialCard
                    marginTop={['xxsmall', 'xxsmall', 'medium', 'medium']}
                >
                    {FooterSocial.map((social) => {
                        return <MapSocial key={social.id} {...social} />
                    })}
                </SocialCard>
            </InformationSection>
            <BottonContent href={`/team/${name}`}>
                {i18n.language === 'es' ? <>Ver Perfil</> : <>View Profile</>}
            </BottonContent>
        </Card>
    )
}
